import React, { useState } from "react";
// import WorkingTimeGraph from "./WorkingTimeGraph";
import LogTimeSpan from "./LogTimeSpan";

function AverageTimeSpentButton({ users }) {
  // use to determine whether the task detail is reveal or hidden
  const [modalAverageTimeSpentButton, setModalAverageTimeSpentButton] = useState(false);
  // reveal the task detail
  const openmodalAverageTimeSpentButton = () => {
    setModalAverageTimeSpentButton(true);
  };

  // make the task detail hidden
  const closemodalAverageTimeSpentButton = () => {
    setModalAverageTimeSpentButton(false);
  };

  return (
    <div>
      <button
        className="bg-[#404040] text-white px-[10px] py-[5px] rounded-xl flex "
        onClick={openmodalAverageTimeSpentButton}
      >
        <div>Average Time Spent</div>
        <div className="mt-[0.5px]">
        </div>
      </button>

      {modalAverageTimeSpentButton === true && (
        <LogTimeSpan users={users} onClose={closemodalAverageTimeSpentButton} />
      )}

    </div>
  );
};

export default AverageTimeSpentButton;
